// Define the `core` module
angular.module('core', ['core.auth', 'core.env']);



// WEBPACK FOOTER //
// ./src/app/core/core.module.js